let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("wmApS")).then(() => parcelRequire('d9zBr'));